module.exports = __webpack_public_path__ + "media/images/v2/file_preview_icon-e1115edbcf5f0c4b8ee1131200aa5686.png";